import styled from "styled-components";
import colors from "constants/colors";
import media from "constants/media";

export const CardNumberInputStyled = styled.div`
    max-width: 310px;
    margin: 20px auto;
    padding: 15px;

    border: ${({ hasError, hasBalance }) => {
        if (hasError) {
            return `1px solid var(--color-red)`;
        }
        if (hasBalance) {
            return `1px solid var(--color-green)`;
        }
        return "1px solid rgba(0, 23, 75, 0.1)";
    }};

    ${media.mdUp`
        max-width: 100%;
        padding: 10px 0;
        border: none;
    `};
`;

export const Input = styled.input`
    width: 48px;
    height: 20px;
    margin-right: 2px;
    padding-left: 2px;

    color: ${({ hasError, hasBalance }) => {
        if (hasError) {
            return colors.red;
        }
        if (hasBalance) {
            return colors.green;
        }
        return colors.darkNight;
    }};
    font-weight: 500;
    font-size: 14px;
    font-family: var(--font-DINPro);
    line-height: 20px;
    letter-spacing: 3px;

    border: none;

    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
        margin: 0;

        appearance: none;
    }

    &[type="number"] {
        /* stylelint-disable-next-line property-no-vendor-prefix */
        -moz-appearance: textfield;
    }

    ::placeholder {
        color: rgba(0, 23, 75, 0.2);
    }

    :last-of-type {
        width: 36px;
        margin-right: 0;
    }

    :disabled {
        background-color: transparent;
    }

    ${media.mdUp`
        width: 120px;
        height: 50px;
        margin-right: 10px;
        padding: 0 28px;

        font-size: 15px;
        font-weight: bold;
        letter-spacing: 10px;
        line-height: 25px;
        text-align: left;

        border: ${({ hasError, hasBalance, disabled }) => {
            if (hasError && !disabled) {
                return `1px solid var(--color-red)`;
            }
            if (hasBalance && !disabled) {
                return `1px solid var(--color-green)`;
            }
            return "1px solid rgba(0, 23, 75, 0.1)";
        }};

        :last-of-type {
            width: 120px;
            margin-right: 0;
            text-indent: 7px;
        }

        :disabled {
            color: rgba(0, 23, 75, 0.5);
        }
    `};
`;

export const Error = styled.div`
    margin-top: 3px;

    color: var(--color-red);
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
`;
